import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './hooks/useAuth';
import Login       from './pages/Login';
import Dashboard   from './pages/Dashboard';
import Leads       from './pages/Leads';
import Sequences   from './pages/Sequences';
import Pipeline    from './pages/Pipeline';
import AIAssistant from './pages/AIAssistant';
import Settings    from './pages/Settings';
import Templates   from './pages/Templates';
import AICalls     from './pages/AICalls';
import WhatsApp    from './pages/WhatsApp';
import Bench       from './pages/Bench';
import Layout      from './components/Layout';

function Protected({ children }) {
  const { user } = useAuth();
  return user ? children : <Navigate to="/login" replace />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Protected><Layout /></Protected>}>
            <Route index              element={<Dashboard />} />
            <Route path="leads"       element={<Leads />} />
            <Route path="sequences"   element={<Sequences />} />
            <Route path="pipeline"    element={<Pipeline />} />
            <Route path="templates"   element={<Templates />} />
            <Route path="aicalls"     element={<AICalls />} />
            <Route path="whatsapp"    element={<WhatsApp />} />
            <Route path="bench"       element={<Bench />} />
            <Route path="ai"          element={<AIAssistant />} />
            <Route path="settings"    element={<Settings />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
